module.exports = __webpack_public_path__ + "static/media/notfound.654a743f.png";